module.exports = __webpack_public_path__ + "code-alert.3EottuLI.svg";